import { useCallback, useState } from 'react'
import { useIntl } from 'react-intl'

import { useAppDispatch } from 'app/hooks'
import useCurrentSelectedDomainId from 'features/DomainsSelector/hooks'
import { DeleteButtonCell } from 'components/Table'
import { Regular, RegularModerate } from 'components/Typography'
import {
  deleteUserFromDomainThunk,
  fetchDomainUsersListThunk,
} from 'features/team/slice'
//import { deleteDomainAdminsThunk } from 'features/networkAi/slice'
//import { RemoveAdmin } from 'features/networkAi/types'
import SuccessModal from 'components/Modal/SuccessModal'
import { teamPageMessages } from 'features/team/messages'
import { commonMessages } from 'app/i18n/messages'

interface DeleteButtonProps {
  id: string
  email: string
}

function DeleteButton({ id: userId, email }: DeleteButtonProps) {
  const dispatch = useAppDispatch()
  const { formatMessage } = useIntl()
  const domainId = useCurrentSelectedDomainId()

  const [showError, setShowError] = useState(false)

  const handleDelete = useCallback(async () => {
    if (domainId && userId && email) {
      try {
        //const deleteDomainAdminBody: RemoveAdmin = { emailId: email }
        await dispatch(deleteUserFromDomainThunk(userId, domainId))
        await dispatch(fetchDomainUsersListThunk(domainId))
        //await dispatch(deleteDomainAdminsThunk(domainId, deleteDomainAdminBody))
      } catch (error) {
        console.log(
          `Error removing user ${userId} from domain  ${domainId}`,
          error
        )
        setShowError(true)
      }
    }
  }, [dispatch, userId, domainId, email])

  return (
    <>
      {showError && (
        <SuccessModal
          isOpen
          confirmBtnTitle={formatMessage(commonMessages.close)}
          title={formatMessage(teamPageMessages.permissionsErrorTitle)}
          onConfirm={() => setShowError(false)}
        >
          <RegularModerate>
            {formatMessage(teamPageMessages.unknownPermissionsUpdateError)}
          </RegularModerate>
        </SuccessModal>
      )}

      <DeleteButtonCell
        title={formatMessage(teamPageMessages.removeUserPopupTitle)}
        handleConfirm={handleDelete}
      >
        <Regular>
          {formatMessage(teamPageMessages.removeUserPopupDesc, {
            email,
            br: <br />,
          })}
        </Regular>
      </DeleteButtonCell>
    </>
  )
}

export default DeleteButton
